import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../Utils/axiosConfig";
import { RecoveryContext } from "../../App";
import { Link } from "react-router-dom";

import logo from "../Assets/Logo.svg";
import gamereview from "../Assets/Game-review.svg";
import ai from "../Assets/AI.svg";
import puzzles from "../Assets/Puzzles.svg";
import book from "../Assets/Book.svg";
import visualisation from "../Assets/Visualisation.svg";
import { TogglePasswordReset } from "./TogglePassword";

export default function Reset() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [visiblePassword, setVisiblePassword] = useState(false);
  const { email } = useContext(RecoveryContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }
    const passwordRegex = /^(?=.*[A-Z]).{8,22}$/;
    if (!passwordRegex.test(password)) {
      setErrorMessage(
        "Password must be 8-22 characters with at least one uppercase letter."
      );
      return;
    }
    try {
      const response = await axios.post("/change-password", {
        email: email,
        newPassword: password,
      });

      console.log(response.data);
      setAlertMessage("Password updated successfully. Please log in.");

      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (error) {
      console.error("Error updating password:", error);
      setErrorMessage("Failed to update password. Please try again.");
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    if (alertMessage) {
      setErrorMessage("");
      const alertTimer = setTimeout(() => {
        setAlertMessage("");
      }, 1500);
      return () => clearTimeout(alertTimer);
    } else if (errorMessage) {
      const errorTimer = setTimeout(() => {
        setErrorMessage("");
      }, 1500);
      return () => clearTimeout(errorTimer);
    }
  }, [alertMessage, errorMessage]);

  return (
    <div className="container login-mobile-layout reset-mobile-layout">
      <header className="header">
        <img className="logo-image" src={logo} alt="logo" />
        <div className="logo-text">
          <span className="C-logo">C</span>
          <span className="hezzle-logo">
            he<span className="Z-1">Z</span>
            <span className="Z-2">Z</span>le
          </span>
        </div>
        <Link to="/login" className="login-button">
          Log in
        </Link>
      </header>
      <div className="gradient-line"></div>
      <div className="left-half">
        <img className="left-image" src={logo} alt="logo" />
        <div className="features">
          <ul>
            <li>
              <img src={gamereview} className="gamereview-svg" alt="" />
              Enhance your game analysis!
            </li>
            <br />
            <li>
              <img src={ai} className="ai-svg" alt="" />
              Get AI-assisted move breakdown.
            </li>
            <br />
            <li>
              <img src={puzzles} className="puzzles-svg" alt="" />
              Exclusive puzzles from your games!
            </li>
            <br />
            <li>
              <img src={book} className="book-svg" alt="" />
              Master your openings and middle game.
            </li>
            <br />
            <li>
              <img src={visualisation} className="visualisation-svg" alt="" />
              Level up your visualization skills!
            </li>
            <br />
          </ul>
        </div>
      </div>

      <div className="signup-form">
        <div className="line"></div>
        <h2 className="welcome">Change password</h2>
        <form
          onSubmit={handleSubmit}
          className="mt-4 space-y-4 lg:mt-5 md:space-y-5"
        >
          <div>
            <input
              type="password"
              placeholder="New password"
              className="password-signup"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div>
            <div className="password-wrapper">
              <input
                type={visiblePassword ? "text" : "password"}
                placeholder="Confirm password"
                className="password-signup"
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
          </div>
          <button type="submit" className="reset-password-button">
            Reset password
          </button>
        </form>
        <div>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          {alertMessage && <p className="alert-message">{alertMessage}</p>}
        </div>
      </div>
    </div>
  );
}
